var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back-drop"},[_c('div',{staticClass:"vue-modal center"},[_c('button',{staticClass:"close",on:{"click":_vm.close}},[_vm._v("x")]),_vm._v(" "),_c('h3',[_vm._t("header")],2),_vm._v(" "),_c('p',[_vm._t("body")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }